<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.extruderQuantity"
            :error-messages="extruderQuantityErrors"
            :label="$t('profile.setupdefinition.extruderquantity')"
            required
            @input="$v.item.extruderQuantity.$touch()"
            @blur="$v.item.extruderQuantity.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.tempControler"
            :error-messages="tempControlerErrors"
            :label="$t('profile.setupdefinition.tempcontroler')"
            required
            @input="$v.item.tempControler.$touch()"
            @blur="$v.item.tempControler.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="machineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.setupdefinition.machine')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolHeadSelectItems"
            v-model="item.toolHead"
            :items="toolHeadSelectItems"
            :error-messages="toolHeadErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.setupdefinition.toolhead')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSupplySelectItems"
            v-model="item.materialSupply"
            :items="materialSupplySelectItems"
            :error-messages="materialSupplyErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.setupdefinition.materialsupply')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="printingSurfaceSelectItems"
            v-model="item.printingSurface"
            :items="printingSurfaceSelectItems"
            :error-messages="printingSurfaceErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.setupdefinition.printingsurface')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'SetupDefinitionForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.machineGetSelectItems();
      this.toolHeadGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.printingSurfaceGetSelectItems();
      this.setupDefinitionSubsGetSelectItems();
  },
  data() {
    return {
        extruderQuantity: null,
        tempControler: null,
        machine: null,
        toolHead: null,
        materialSupply: null,
        printingSurface: null,
        setupDefinitionSubs: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_machine ||
         this.isLoading_toolhead ||
         this.isLoading_materialsupply ||
         this.isLoading_printingsurface ||
         this.isLoading_setupdefinitionsub
       );
    },
      ...mapFields('machine', {
        machineSelectItems: 'selectItems',
        isLoading_machine : 'isLoading'
      }),
      ...mapFields('toolhead', {
        toolHeadSelectItems: 'selectItems',
        isLoading_toolhead : 'isLoading'
      }),
      ...mapFields('materialsupply', {
        materialSupplySelectItems: 'selectItems',
        isLoading_materialsupply : 'isLoading'
      }),
      ...mapFields('printingsurface', {
        printingSurfaceSelectItems: 'selectItems',
        isLoading_printingsurface : 'isLoading'
      }),
      ...mapFields('setupdefinitionsub', {
        setupDefinitionSubsSelectItems: 'selectItems',
        isLoading_setupdefinitionsub : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    extruderQuantityErrors() {
      const errors = [];

      if (!this.$v.item.extruderQuantity.$dirty) return errors;

      has(this.violations, 'extruderQuantity') && errors.push(this.violations.extruderQuantity);

      !this.$v.item.extruderQuantity.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    tempControlerErrors() {
      const errors = [];

      if (!this.$v.item.tempControler.$dirty) return errors;

      has(this.violations, 'tempControler') && errors.push(this.violations.tempControler);

      !this.$v.item.tempControler.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    machineErrors() {
      const errors = [];

      if (!this.$v.item.machine.$dirty) return errors;

      has(this.violations, 'machine') && errors.push(this.violations.machine);


      return errors;
    },
    toolHeadErrors() {
      const errors = [];

      if (!this.$v.item.toolHead.$dirty) return errors;

      has(this.violations, 'toolHead') && errors.push(this.violations.toolHead);


      return errors;
    },
    materialSupplyErrors() {
      const errors = [];

      if (!this.$v.item.materialSupply.$dirty) return errors;

      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);


      return errors;
    },
    printingSurfaceErrors() {
      const errors = [];

      if (!this.$v.item.printingSurface.$dirty) return errors;

      has(this.violations, 'printingSurface') && errors.push(this.violations.printingSurface);


      return errors;
    },
    setupDefinitionSubsErrors() {
      const errors = [];

      if (!this.$v.item.setupDefinitionSubs.$dirty) return errors;

      has(this.violations, 'setupDefinitionSubs') && errors.push(this.violations.setupDefinitionSubs);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
      ...mapActions({
        toolHeadGetSelectItems: 'toolhead/fetchSelectItems'
      }),
      ...mapActions({
        materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
      ...mapActions({
        printingSurfaceGetSelectItems: 'printingsurface/fetchSelectItems'
      }),
      ...mapActions({
        setupDefinitionSubsGetSelectItems: 'setupdefinitionsub/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      extruderQuantity: {
        required,
      },
      tempControler: {
        required,
      },
      machine: {
      },
      toolHead: {
      },
      materialSupply: {
      },
      printingSurface: {
      },
      setupDefinitionSubs: {
      },
    }
  }
};
</script>
